import { CourtEnum } from "./courtEnum";
import { LocationEnum } from "./locationEnum";

export interface ImageInfo {
  url: string;
  author?: string;
  authorUrl?: string;
  licence?: string;
  licenceUrl?: string;
}

export interface Assets {
  blog: {
    zfKoblenz: string;
    stabilusKoblenz: string;
  };
  solvingTax: {
    logoWithGradient: string;
  };
  logos: {
    white: string;
    black: string;
  };
  videos: {
    headerVideo: string;
  };
  images: {
    landingpages: {
      vertrag1: string;
      vertrag2: string;
    };
    expertise: {
      arbeitsrecht: string;
      gesellschaftsrecht: string;
      erbrecht: string;
      startuprecht: string;
      steuerrecht: string;
      prozessfuehrung: string;
      internetmedienrecht: string;
      insolvenzrecht: string;
    };
    courts: Record<string, ImageInfo>;
    persons: {
      moritz: Record<1050 | 600, string>;
      hubi: Record<1050 | 600, string>;
    };
    locations: Record<LocationEnum, string>;
    abstract: Record<1 | 2, string>;
    icons: {
      leftQuote: string;
    };
  };
}

export const assetPaths: Assets = {
  blog: {
    zfKoblenz: "/images/blog/zf-koblenz.jpg",
    stabilusKoblenz: "/images/blog/stabilus-koblenz.tif",
  },
  logos: {
    white: "/logo/white.svg",
    black: "/logo/black.svg",
  },

  videos: {
    headerVideo: "/videos/SLGradient.mp4",
  },

  solvingTax: {
    logoWithGradient: "/logo/st-with-gradient.png",
  },

  images: {
    landingpages: {
      vertrag1: "/images/landingpages/aufhebungsvertrag.jpg",
      vertrag2: "/images/landingpages/vertrag.jpg",
    },
    expertise: {
      arbeitsrecht: "/images/expertise/arbeitsrecht.jpg",
      gesellschaftsrecht: "/images/expertise/gesellschaftsrecht.jpg",
      erbrecht: "/images/expertise/erbrecht.jpg",
      startuprecht: "/images/expertise/startup.jpg",
      steuerrecht: "/images/expertise/steuerrecht.jpg",
      prozessfuehrung: "/images/expertise/prozessfuehrung.jpg",
      internetmedienrecht: "/images/expertise/internetmedienrecht.jpg",
      insolvenzrecht: "/images/expertise/insolvenzrecht.jpg", // TODO: Eigenes Insolvenzrecht-Bild hinzufügen
    },

    courts: {
      [CourtEnum.HeilbronnLg]: {
        url: "/images/courts/lg-heilbronn.jpg",
        licence: "CC BY-SA 3.0",
        licenceUrl: "https://creativecommons.org/licenses/by-sa/3.0",
        author: "p.schmelzle",
        authorUrl: "https://commons.wikimedia.org/w/index.php?curid=3142954",
      },
      [CourtEnum.KaiserslauternLg]: {
        url: "/images/courts/ag-kaiserslautern.jpg",
        licence: "CC BY-SA 4.0",
        licenceUrl: "https://creativecommons.org/licenses/by-sa/4.0",
        author: "Subamaggus",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Subamaggus",
      },
      [CourtEnum.KoblenzLG]: {
        url: "/images/courts/koblenz-lg.jpg",
        licence: "CC BY-SA 4.0",
        licenceUrl: "https://creativecommons.org/licenses/by-sa/4.0",
        author: "Asperatus",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Asperatus",
      },
      [CourtEnum.KoblenzOLG]: {
        url: "/images/courts/koblenz-olg.jpg",
        licence: "CC BY-SA 3.0",
        licenceUrl: "http://creativecommons.org/licenses/by-sa/3.0/",
        author: "Holger Weinandt",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Holger_Weinandt",
      },
      [CourtEnum.KoblenzArbG]: {
        url: "/images/courts/koblenz-arbg.png",
      },
      [CourtEnum.RlpLag]: {
        url: "/images/courts/mainz-larbg.jpg",
        author: "Stefan Frerichs",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Stefan_Frerichs",
        licence: "CC BY-SA 2.0 de",
        licenceUrl: "https://creativecommons.org/licenses/by-sa/2.0/de/deed.en",
      },
      [CourtEnum.LandauLg]: {
        url: "/images/courts/landau-lg.jpg",
        licence: "CC BY-SA 3.0",
        licenceUrl: "http://creativecommons.org/licenses/by-sa/3.0/",
        author: "BertholdD",
        authorUrl: "https://commons.wikimedia.org/wiki/User:BertholdD",
      },
      [CourtEnum.LudgwigshafenArbG]: {
        url: "/images/courts/ludwigshafen-arbg.jpg",
        author: "Rudolf Stricker",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Rudolf_Stricker",
      },
      [CourtEnum.ZweibrueckenOlg]: {
        url: "/images/courts/zweibrücken-olg.jpg",
        licence: "CC BY-SA 3.0",
        licenceUrl: "http://creativecommons.org/licenses/by-sa/3.0/",
        author: "E.peiffer@gmx.net",
        authorUrl: "https://commons.wikimedia.org/wiki/User:E.peiffer@gmx.net",
      },
      [CourtEnum.StuttgartArbg]: {
        url: "/images/courts/stuttgart-arbg.jpg",
        author: "Stefan Frerichs",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Stefan_Frerichs",
        licence: "CC BY-SA 2.0 de",
        licenceUrl: "https://creativecommons.org/licenses/by-sa/2.0/de/deed.en",
      },
      [CourtEnum.StuttgartLg]: {
        url: "/images/courts/stuttgart-lg.jpg",
      },
      [CourtEnum.StuttgartOlg]: {
        url: "/images/courts/stuttgart-olg.jpg",
        author: "Tresckow",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Tresckow",
        licence: "CC BY-SA 3.0",
        licenceUrl: "http://creativecommons.org/licenses/by-sa/3.0/",
      },
      [CourtEnum.BwLarbg]: {
        url: "/images/courts/bw-larbg.jpg",
        author: "Bubo",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Bubo",
        licence: "CC BY-SA 3.0",
        licenceUrl: "http://creativecommons.org/licenses/by-sa/3.0/",
      },
      [CourtEnum.BwFg]: {
        url: "/images/courts/bw-fg.jpg",
        author: "Bubo",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Bubo",
        licence: "CC BY-SA 3.0",
        licenceUrl: "http://creativecommons.org/licenses/by-sa/3.0/",
      },
      [CourtEnum.CommercialCourtBW]: {
        url: "/images/courts/commercial-court-logo.svg",
      },
      [CourtEnum.StuttgartAg]: {
        url: "/images/courts/stuttgart-lg.jpg",
        // Laut Wikipedia keine Namensnennung erforderlich
      },
      [CourtEnum.LandauAg]: {
        url: "/images/courts/landau-lg.jpg",
        licence: "CC BY-SA 3.0",
        licenceUrl: "http://creativecommons.org/licenses/by-sa/3.0/",
        author: "BertholdD",
        authorUrl: "https://commons.wikimedia.org/wiki/User:BertholdD",
      },
      [CourtEnum.RlpFg]: {
        url: "/images/courts/rlp-fg.jpg",
        // Laut Wikipedia keine Namensnennung erforderlich
      },
      [CourtEnum.KoblenzAG]: {
        url: "/images/courts/koblenz-lg.jpg",
        licence: "CC BY-SA 4.0",
        licenceUrl: "https://creativecommons.org/licenses/by-sa/4.0",
        author: "Asperatus",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Asperatus",
      },
      [CourtEnum.MunichLGI]: {
        url: "/images/courts/muenchen-lg-i.jpg",
        licence: "CC BY-SA 3.0",
        licenceUrl: "http://creativecommons.org/licenses/by-sa/3.0/",
        author: "Richard Huber ",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Richard_Huber ",
      },
      [CourtEnum.MunichOLG]: {
        url: "/images/courts/muenchen-olg.jpg",
        licence: "CC BY-SA 3.0",
        licenceUrl: "http://creativecommons.org/licenses/by-sa/3.0/",
        author: "Christian Wolf (www.c-w-design.de)",
        authorUrl: "https://commons.wikimedia.org/wiki/User:Dr._Chriss",
      },
    },

    persons: {
      moritz: {
        1050: "/images/persons/moritz-riehl-1050.jpg",
        600: "/images/persons/moritz-riehl-600.jpg",
      },
      hubi: {
        1050: "/images/persons/hubertus-scherbarth-1050.jpg",
        600: "/images/persons/hubertus-scherbarth-600.jpg",
      },
    },
    locations: {
      [LocationEnum.FrankfurtAmMain]: "/images/locations/frankfurt-am-main.jpg",
      [LocationEnum.Stuttgart]: "/images/locations/stuttgart.jpg",
      [LocationEnum.Landau]: "/images/locations/landau.jpg",
      [LocationEnum.Koblenz]: "/images/locations/koblenz.jpg",
      [LocationEnum.München]: "/images/locations/munchen.jpg",
      [LocationEnum.Kaiserslautern]: "/images/locations/kaiserslautern.jpg",
      [LocationEnum.Köln]: "/images/locations/koeln.jpg",
      [LocationEnum.Pirmasens]: "/images/locations/pirmasens.jpg",
      [LocationEnum.Heilbronn]: "/images/locations/heilbronn.jpg",
    },

    abstract: {
      1: "/images/abstract/1.png",
      2: "/images/abstract/2.png",
    },

    icons: {
      leftQuote: "/images/icons/left-quote.svg",
    },
  },
};
